import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto cuesta el servicio?',
  answer: 'Cada plan se personaliza según el tamaño de tu spa, tus servicios y tus metas. En la llamada estratégica gratuita analizamos tu situación y te presentamos opciones claras. No hay sorpresas.'
}, {
  question: '¿En cuánto tiempo veré resultados?',
  answer: 'La mayoría de nuestros clientes ven sus primeras citas premium en las primeras 2-3 semanas. Resultados consistentes y escalables se consolidan entre el mes 2 y 3.'
}, {
  question: 'Ya intenté publicidad en Facebook/Instagram y no funcionó. ¿Por qué sería diferente?',
  answer: 'La mayoría de agencias crean anuncios genéricos. Nosotros operamos un sistema completo: segmentación premium, posicionamiento de lujo y retención automatizada. No es solo un anuncio — es una máquina de adquisición de clientes de alto valor.'
}, {
  question: '¿Funciona para mi tipo de spa/clínica?',
  answer: 'Trabajamos con spas médicos, clínicas estéticas, salones de belleza premium, centros de bienestar y cualquier negocio de estética que ofrezca tratamientos de $100+. Si tu servicio tiene valor real, podemos atraer clientes que lo paguen.'
}, {
  question: '¿Necesito un presupuesto grande para publicidad?',
  answer: 'Recomendamos un mínimo de $500-$1,000/mes en inversión publicitaria para empezar. Con nuestra optimización, ese presupuesto genera un retorno de 3-5x en promedio. Empezamos conservador y escalamos con resultados.'
}, {
  question: '¿Qué pasa si no me gustan los resultados?',
  answer: 'Trabajamos mes a mes, sin contratos a largo plazo. Si en algún momento no estás satisfecha, puedes cancelar. Así de simple. Nuestra retención del 94% habla por sí sola.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-28 px-4 bg-carbon relative border-t border-border" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-79">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold tracking-tight" data-id="element-80">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-81">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} className="bg-surface border border-border rounded-2xl overflow-hidden" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} data-id="element-82">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-83">
                  <span className="text-lg font-bold text-white pr-8" data-id="element-84">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-gold shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-85" />
                </button>

                <AnimatePresence initial={false} data-id="element-86">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-87">
                      <div className="px-6 pb-6 pt-0 text-neutral-300 leading-relaxed" data-id="element-88">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}